<template lang="pug">
  div(v-loading="!ready" style="padding:10px")
    div(class="mb5")
      span 提示：橘色框为随项目自动更新的内容；蓝色框填写内容会保存在项目上，并且再次打开不会清空；
      peixun(type="26" style="display:inline-block;margin-left:5px;position:relative;top:3px")
    table(border="1" cellspacing="0" cellpadding="0" width="100%")
      tr(style="background-color:#95B3D7")
        th(class="ft-large" colspan="7" style="line-height:2") {{ reportData.title }}
      tr(style="text-align:center;background-color:rgba(255, 109, 0, 0.7);")
        td(class="ft-large" colspan="7" title="客户对于人选的核心要求") 项目要求
      tr(style="text-align:center")
        td(colspan="7") {{ reportData.yaoqiu }}
      tr(style="text-align:center;background-color:rgba(255, 109, 0, 0.7);")
        td(class="ft-large" title="符合要求人数") 符合要求(人数)
        td(class="ft-large" title="搜索公司" colspan="4") 搜索公司
        td(class="ft-large" title="已经沟通人数") 已经沟通(人数)
        td(class="ft-large" ) 推荐(人数)
      tr(style="text-align:center")
        td {{ reportData.candiNum }}
        td(colspan="4" style="max-width: 25vw;") {{ reportData.company }}
        td {{ reportData.calledNum }}
        td {{ reportData.tuiNum }}
      tr(style="text-align:center;background-color:rgba(255, 109, 0, 0.7);")
        td(class="ft-large" title="推荐人选姓名") 推荐人选
        td(class="ft-large" ) 任职公司
        td(class="ft-large" ) 人选目前进度
        td(class="ft-large" ) 推荐重点
        td(class="ft-large" ) 推荐概述
        td(class="ft-large" colspan="2" ) 备注
      tr(v-for="tui,k in reportData.tuiData" :key="k" style="text-align:center;")
        td {{ tui['姓名'] }}
        td {{ tui['公司'] }}
        td {{ tui['进度'] }}
        td {{ tui['推荐度'] }}
        td(style="min-width:25vw;")
          textarea(v-model="tui['推荐概述']", type="textarea", placeholder="", rows="5",  class="text_cell")
        td(colspan="2")
          textarea(v-model="tui['备注']", type="textarea", placeholder="", rows="5", class="text_cell")
      tr(style="text-align:center;background-color:#95B3D7")
        td(class="ft-large" colspan="7") 不考虑的原因
      tr
        td(colspan="7")
          textarea(v-model="reportData.reason", type="textarea", placeholder="此处填写内容会保存在项目报告上，再次打开报告内容不会清空", rows="5" class="text_cell")
      tr(style="text-align:center;background-color:#95B3D7")
        td(class="ft-large" colspan="7") 市场情况
      tr
        td(colspan="7")
          textarea(v-model="reportData.market", type="textarea", placeholder="此处填写内容会保存在项目报告上，再次打开报告内容不会清空", rows="5" class="text_cell")
      tr(style="text-align:center;background-color:#95B3D7")
        td(class="ft-large" colspan="7") 阿尔法建议
      tr
        td(colspan="7")
          textarea(v-model="reportData.advice", type="textarea", placeholder="此处填写内容会保存在项目报告上，再次打开报告内容不会清空", rows="5" class="text_cell")
      tr(style="text-align:center;background-color:#95B3D7")
        td(class="ft-large" colspan="7", title="未沟通原因 已经沟通说明") 备注
      tr
        td(colspan="7")
          textarea(v-model="reportData.beizhu", type="textarea", placeholder="此处填写内容会保存在项目报告上，再次打开报告内容不会清空", rows="5" class="text_cell")
    a(:href="link", ref='download', :download="fname")
    div(style="padding:10px;text-align:right")
      el-button(@click="save" :loading="saving" type="primary") 保存
      el-button(@click="download" type="primary") 生成Excel报告
</template>

<script>
// Generated by CoffeeScript 2.3.0
let m
const dateFormat = require('dateformat')

const rank = {
  1: '高管',
  2: '部门总',
  3: '部门副总-总助-团队长',
  4: '部门核心骨干',
  5: '新人（三年以下）',
}

const pingtaiMap = {
  A: '大',
  B: '中',
  C: '小',
}

const yejiMap = {
  aaa: '领军',
  aa: '卓越',
  a: '优秀',
  b: '良好',
  c: '一般',
  d: '较差',
}

const num2Str = {
  1: '一',
  2: '二',
  3: '三',
  4: '四',
  5: '五',
  6: '六',
  7: '七',
  8: '八',
}

export default (m = {
  props: {
    projectId: String,
  },
  data: function() {
    return {
      ready: false,
      link: '',
      fname: '',
      reportData: {
        title: '',
        yaoqiu: '',
        candiNum: '',
        calledNum: '',
        beizhu: '',
        tuiNum: '',
        tuiData: [],
        reason: '',
        market: '',
        advice: '',
        company: '',
      },
      saving: false,
    }
  },
  methods: {
    save: async function() {
      const dt = {
        备注: this.reportData.beizhu,
        不考虑的原因: this.reportData.reason,
        市场情况: this.reportData.market,
        阿尔法建议: this.reportData.advice,
      }
      this.saving = true
      try {
        await app.service('project').upsertProjectReport({ pid: this.projectId, data: dt })
        this.saveRecomendDesc()
        this.$message({
          type: 'success',
          message: '保存成功',
        })
      } catch (e) {
        this.$message({
          type: 'error',
          message: e.message,
        })
      }
      this.saving = false
    },
    async saveRecomendDesc() {
      const data = {}
      this.reportData.tuiData.forEach(radish => {
        if (!radish['推荐概述']) return
        app.service('project').upsertRadishRecommendReport({ rid: radish.rid, form: { 优势: radish['推荐概述'] } })
      })
    },
    download: async function() {
      const dt = JSON.parse(JSON.stringify(this.reportData))
      dt.pid = this.projectId
      await app.service('project').saveRecords({
        type: '项目推荐人选汇总',
        path: '项目操作下拉框',
        page: '项目详情',
        data: { pid: this.projectId },
      })
      return app.api
        .exportReport({
          data: dt,
        })
        .then(pack => {
          let fname, stream
          ;({ fname, stream } = pack)
          this.link = `data:application/octet-stream;charset=utf-8;base64,${stream}`
          this.fname = fname
          return this.$nextTick(() => this.$refs.download.click())
        })
    },
    formatRank(val) {
      if (!val) return ''
      if (Array.isArray(val)) {
        let result = ''
        const length = val.length
        val.map((v, i) => {
          if (!v || !rank[v]) return ''
          result += rank[v] + (val.length - 1 !== i ? ',' : '')
        })
        return result
      } else {
        return val
      }
    },
    formatZhineng(val) {
      if (!val || val.length === '') return ''
      const str = val.toString()
      const pattern = new RegExp("[`~!@#$^&*()=|{}':;'\\[\\]<>/?~！@#￥……&*（）——|{}【】‘；：”“'。，、？\\s+{0-9}]")
      let result = ''
      for (let i = 0; i < str.length; i += 1) {
        result += str.substr(i, 1).replace(pattern, '')
      }
      return result
    },
    async getCalledNum(rids) {
      try {
        this.reportData.calledNum = await app.service('communication').countByRids({ rids })
      } catch (e) {
        console.error(e)
      }
    },
    async getCandiNum(pid) {
      try {
        this.reportData.candiNum = await app.service('project').projectRadishesCount(pid)
      } catch (e) {
        console.error(e)
      }
    },
    async loadProjectReport(pid) {
      try {
        const data = await app.service('project').fetchProjectReport({ pid })
        if (!data) return
        this.reportData.beizhu = data['备注']
        this.reportData.reason = data['不考虑的原因']
        this.reportData.market = data['市场情况']
        this.reportData.advice = data['阿尔法建议']
      } catch (e) {
        console.error(e)
      }
    },
    getTag(row) {
      if (!row.状态 || !row.状态.tag) {
        return 'Call'
      } else if (row.状态.tag === '过保') {
        if (row.状态.detail === '淘汰' || row.状态.detail === '放弃') {
          return '未过保'
        }
        return '过保'
      } else if (row.状态.detail === '淘汰' || row.状态.detail === '放弃') {
        return `已${row.状态.detail}`
      } else if (row.状态.tag === '已推荐') {
        return '推荐'
      } else if (row.状态.tag === '面试') {
        if (row.状态.detail === '终面') {
          return '终面'
        } else {
          return `面试${row.状态.detail}`
        }
      } else if (row.状态.tag === 'offer谈判') {
        return 'offer谈判'
      } else if (row.状态.tag === 'offer') {
        return '离职辅导'
      } else if (row.状态.tag === '到岗') {
        return '到岗'
      }
      return ''
    },
    async fetchRadishProcess(rids) {
      if (rids.length > 0) {
        const toworks = await app.service('project').radishProcess({ rids, pid: this.projectId, process: 'toworks' })
        toworks.map(v => {
          this.reportData.tuiData.map(r => {
            if (!r['进度'] && r.rid === v.rid) {
              r['进度'] = `到岗：${v['到岗日期'].split(' ')[0]}`
            }
          })
        })
        const interviews = await app
          .service('project')
          .radishProcess({ rids, pid: this.projectId, process: 'interviews' })
        interviews.map(item => {
          this.reportData.tuiData.map(r => {
            if (r.rid === item.rid) {
              if (item.isFinal) {
                r['进度'] = `终面：${item['面试时间'].split(' ')[0]}`
              } else if (!r.round) {
                r['进度'] = `${num2Str[item.round]}面：${item['面试时间'].split(' ')[0]}`
              } else if (item.round > r.round) {
                r['进度'] = `${num2Str[item.round]}面：${item['面试时间'].split(' ')[0]}`
              }
            }
          })
        })
        const recommends = await app
          .service('project')
          .radishProcess({ rids, pid: this.projectId, process: 'recommends' })
        recommends.map(v => {
          this.reportData.tuiData.map(r => {
            if (!r['进度'] && r.rid === v.rid) {
              r['进度'] = `推荐未安排面试：${dateFormat(new Date(parseInt(v.updatedAt, 10)), 'yyyy-mm-dd')}`
            }
          })
        })
      }
    },
    formatPingtai(val) {
      const valArr = Array.isArray(val) ? val : [val]
      const words = valArr.map(va => pingtaiMap[va] || va)
      return words.length === 0 ? '' : `来自于${words.join('、')}平台；`
    },
    formatYeji(val) {
      const valArr = Array.isArray(val) ? val : [val]
      const words = valArr.map(va => yejiMap[va] || va)
      return words.length === 0 ? '' : `业绩表现${words.join('、')}；`
    },
  },
  mounted: async function() {
    if (!this.projectId) return
    try {
      const pro = await app.service('project').fetch(this.projectId)
      await this.loadProjectReport(pro._id)
      this.reportData.title = `${pro['客户公司']}-${pro['部门']}-${pro['项目名称']}-${dateFormat(
        new Date(parseInt(Date.now(), 10)),
        'yyyy.mm.dd',
      )}-项目搜索进度报告`
      const yaoqiuArr = []
      if (pro['平台']) {
        yaoqiuArr.push(this.formatPingtai(pro['平台']))
      }
      if (pro['职能模块'] && pro['职能模块'].length > 0) {
        yaoqiuArr.push(`主要工作职能为${pro['职能模块']}；`)
      }
      if (pro['细分职能'] && pro['细分职能'].length > 0) {
        yaoqiuArr.push(`专注于${pro['细分职能'].toString()}领域；`)
      }
      if (pro['擅长方向'] && pro['擅长方向'].length > 0) {
        yaoqiuArr.push(`擅长${pro['擅长方向'].toString()}方向的工作；`)
      }
      if (pro['职级'] && pro['职级'].length > 0) {
        yaoqiuArr.push(`职级为${this.formatRank(pro['职级'])}；`)
      }
      if (pro['业绩'] && pro['业绩'].length > 0) {
        yaoqiuArr.push(this.formatYeji(pro['业绩']))
      }
      let yaoqiuStr = ''
      if (yaoqiuArr.length > 0) {
        yaoqiuStr = yaoqiuArr.join('')
        yaoqiuStr = yaoqiuStr.substring(0, yaoqiuStr.length - 1)
        yaoqiuStr += '的人选'
      }
      this.reportData.yaoqiu = yaoqiuStr
      // this.reportData.yaoqiu = `${pro['平台'] ? `平台：${pro['平台']}` : ''} ${
      //   pro['职级'] ? `职级：${this.formatRank(pro['职级'])}` : ''
      // } ${pro['细分职能'] ? `职能：${this.formatZhineng(pro['细分职能'])}` : ''}${
      //   pro['业绩'] ? ` 业绩：${pro['业绩']}` : ''
      // } ${pro['岗位要求'] ? `要求：${pro['岗位要求']}` : ''}`
      if (pro['报告']) {
        this.reportData.beizhu = pro['报告']['备注'] || ''
        this.reportData.reason = pro['报告']['不考虑的原因'] || ''
        this.reportData.market = pro['报告']['市场情况'] || ''
        this.reportData.advice = pro['报告']['阿尔法建议'] || ''
      }
      const data = await app.service('project').projectRecommends(pro._id)
      const companiesNames = {}
      let allProjectRadishes = []
      const allRes = await app.service('radish').findByProject({ pid: pro._id })

      if (allRes && allRes.status === 'success') {
        this.reportData.candiNum = allRes.data.total || 0
        this.reportData.calledNum = allRes.data.total || 0
        allProjectRadishes = (allRes.data && allRes.data.data) || []
      }
      const reason = []
      for (const doc of data) {
        const pi = await app.service('radish').initRecommendText({ rid: doc.rid, pid: doc.pid })
        doc.推荐概述 = pi.data.pipeiduText
        doc.推荐度 = doc.推荐度 || '--'
        if (doc && doc.公司) {
          companiesNames[doc.公司] = 1
        }
        if (doc.推荐反馈) {
          const failedFeedbacks = doc.推荐反馈.filter(v => v.人选意愿 === '放弃').map(v => v.内容)
          reason.push(...failedFeedbacks)
        }
        const radishProject = allProjectRadishes.find(apr => apr.rid === doc.rid && apr.pid === doc.pid)
        if (radishProject) {
          let status = this.getTag(radishProject)
          const processLogs = await app.service('radish').getProgressLog({ rid: doc.rid, pid: doc.pid })
          if (processLogs && processLogs.status === 'success') {
            status += ` (${processLogs.data &&
              processLogs.data[0] &&
              processLogs.data[0].timestamp &&
              processLogs.data[0].timestamp.split(' ')[0]})`
          }
          doc.进度 = status
        }
      }
      if (!this.reportData.reason) {
        let reasonStr = ''
        reason.forEach((r, index) => {
          reasonStr += `${index + 1}. ${r};\n`
        })
        this.reportData.reason = reasonStr
      }
      this.reportData.tuiData = data
      this.reportData.company = Object.keys(companiesNames).join(';')
      const rids = data.map(r => r.rid)
      this.reportData.tuiNum = data.length
      if (rids.length === 0) {
        this.$message.error(`当前没有推荐人选，请推荐人选之后重试`)
        this.ready = true
        window.close()
        return
      }

      // await this.fetchRadishProcess(rids)
      // this.getCalledNum(rids)
      // this.getCandiNum(pro._id)
      this.$nextTick(() => {
        this.ready = true
      })
    } catch (e) {
      this.$message.error(e.message)
    }
  },
})
</script>

<style scoped>
.text_cell {
  width: 100%;
  height: 100%;
  resize: vertical;
}
</style>
